module.exports = __webpack_public_path__ + "img/epesis.29448e30.png";